import React from 'react';
const BaseURL = process.env.REACT_APP_BASE_URL;

/**
 * Arena Table component
 * @param {number} tableNumber
 * @param {number} tablePrice
 * @param {string} tableState ['booked', 'hold', 'selected', 'available', 'NA', 'system']
 * @returns JSX Arena Table
 */
export default function ArenaTable({ tableNumber, tablePrice, renderPrice = false, onClick, customClassName = "", state = 'available', ...props }) {

    const mapStateToHtmlClass = {
        "booked": "isBookedTable",
        "hold": 'isHoldedTable',
        "selected": 'isSelectedTable',
        "available": '',
        "NA": 'notavailableTable',
        "system": "isSystemTable"
    }

    if (!!onClick && onClick.constructor !== Function) {
        throw new Error("onClick is required and to be a function.");
    }

    return (
        <div
            className={`bookingTable ${mapStateToHtmlClass[state]} ${customClassName}`}
            onClick={['available', 'selected'].indexOf(state) > -1 ? onClick : null}
            {...props}
        >
            <img src={`${BaseURL}/assets/img/bookingtable.png`} alt={`Table ${tableNumber}`} />
            {!!tablePrice && tablePrice > 0 &&
                <div style={{ fontSize: '9px', position: 'relative', display: renderPrice ? 'block' : 'none' }}>
                    {tablePrice.toLocaleString('en-US')}
                    <span style={{ fontSize: 5, position: 'absolute', bottom: -4, right: 0 }}>AED</span>
                </div>
            }
            <div className={`TableNumber ${renderPrice ? '' : 'mt-2'}`}>
                {tableNumber}
            </div>
        </div>
    );
}
